import React, { useState, useEffect } from 'react'
import './styles.css'


export default ({ menuId, isOpen, nodeId, actions, actionIcons, handleAction, handleClose, position }) => {

  const handleWindowClick = (e) => {
    const menu = document.getElementById(menuId)
    if (!menu.contains(e.target)) {
      handleClose() // clicked outside the menu, so close it
    }
  }

  const handleMenuClick = (e, nodeId, actionId) => {
    handleClose() // close the menu
    handleAction(e, nodeId, actionId)
  }

  useEffect(() => {
    window.addEventListener('click', handleWindowClick)
    return () => window.removeEventListener('click', handleWindowClick)
  }, [])

  // const style = (side === 'left') ?
  //   {
  //     left: open ? '0px' : '-12em',
  //   } : {
  //     right: open ? '0px' : '-12em',
  //   }

  // set popup menu at the edge of the navbar
  // const nav = document.getElementsByClassName('nodes')
  // const navWidth = nav && nav[0] && nav[0].offsetWidth || 0
  const style = {
    display: isOpen ? 'inline' : 'none',
    // left: String(navWidth) + 'px',
    left: String(position[0]) + 'px',
    top: String(position[1]) + 'px',
  }

  return (
    <span className="popup-menu" id={menuId} style={style} >
      {actions.map((action, index) => (
        <div key={action.id + String(index)} onClick={(e) => handleMenuClick(e, nodeId, action.id)}>
          <span className="action-icon">{actionIcons[action.id] || ' '}</span>
          <span className="action-name" title={action.description}>{action.name}</span>
        </div>
      ))}
    </span>
  )
}
